import * as React from 'react';

import { cn } from '@/shared/lib/utils';

// shadcn/ui Skeleton primitive (new-york). Repo-local baseline – Phoenix wrapper viz `@/shared/ui/skeleton`.
function ShadcnSkeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export { ShadcnSkeleton };
